import Service from "../../Services";

const Membership = {
    namespaced : true,
    state : {
        memberships : [],
    },
    mutations : {
        SET_MEMBERSHIPS : (state,res)=>{
            state.memberships = res;
        }
    },
    actions : {
        // eslint-disable-next-line no-unused-vars
        getMembershipByBranch({commit}, {branch_id,lang}) {
            return Service.MembershipAPI.getMembershipByBranch(branch_id,lang).then(res=>{
                commit('SET_MEMBERSHIPS',res);
            })
        },
        // eslint-disable-next-line no-unused-vars
        getMembersAll({commit},lang='th'){
            return Service.MembershipAPI.getMembersAll(lang)
        },
        // eslint-disable-next-line no-unused-vars
        getMemberShipRateByBranch({commit},{lang='th',branch_id = 1}){
            return Service.MembershipAPI.getMemberShipRateByBranch(lang,branch_id)
        },
        // eslint-disable-next-line no-unused-vars
        getMembershipBenefitAll({commit},lang='th'){
            return Service.MembershipAPI.getMemberShipBenefitAll(lang)
        },
    },
}
export default Membership
